import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { ResultsSection, WashingSection } from './Sections';

const qestIds = [ids.wash.AS_1289_3_6_1.Rev2009];

let As1289_3_6_1_MeasuredWashSievingWorksheet: WorksheetRootComponent = () => (
  <>
    <WashingSection />
    <ResultsSection />
  </>
);

As1289_3_6_1_MeasuredWashSievingWorksheet.qestIds = qestIds;
As1289_3_6_1_MeasuredWashSievingWorksheet = withInjectedProps(As1289_3_6_1_MeasuredWashSievingWorksheet);

export default As1289_3_6_1_MeasuredWashSievingWorksheet;
export { As1289_3_6_1_MeasuredWashSievingWorksheet };
